import {RouteRecordRaw} from "vue-router";
import StripeConnectOnboardingView from "@/stripe-connect/views/StripeConnectOnboardingView.vue";

const routes: RouteRecordRaw[] = [
    {
        path: '/stripe/connect/onboarding',
        name: 'stripe-connect.onboarding',
        component: StripeConnectOnboardingView,
        meta: {
            title: 'Encaissement en ligne'
        }
    }
];

export default routes;
